import { render, staticRenderFns } from "./paired.vue?vue&type=template&id=144d67ca&scoped=true"
import script from "./paired.vue?vue&type=script&lang=js"
export * from "./paired.vue?vue&type=script&lang=js"
import style0 from "./paired.vue?vue&type=style&index=0&id=144d67ca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144d67ca",
  null
  
)

export default component.exports